<template>
  <v-dialog v-model="show" width="450" persistent>
    <v-card>
      <v-card-title>
        <v-flex grow>
          <v-menu class="mr-0" bottom left offset-y origin="right top" transition="scale-transition"
            v-if=!$isPhoneDevice>
            <v-btn icon slot="activator">
              <v-icon>help_outline</v-icon>
            </v-btn>
            <v-card class="elevation-11 white" raised color max-width="350">
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-2">
                    <v-icon>search</v-icon>
                    {{ $t("Powerbox.Labels.SearchTipTitle") }}
                  </h3>
                  <p>{{ $t('SpecificConditions.Labels.textInfo') }}</p>
                </div>
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed :color="skin.primary_color" class="subPrimary--text">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-flex>
        <v-flex class="ml-0">
          <h2 class="font-weight-light ">
            {{ $t("SpecificConditions.Title") }}
          </h2>
        </v-flex>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form v-if="specificConditionsQuestions" v-model="valid" lazy-validation ref="scqForm">
          <v-layout column wrap dense v-for="(question, index) in this.specificConditionsQuestions"
            :key="question.questionCode + index">
            <v-flex>
              <h3>{{ question.question }}</h3>
              <v-radio-group :value="question.selectedAnswerCode" required mandatory
                :rules="[v => !!v || 'Required field']" @change="setAnswer(question, index, $event)">
                <v-radio :color="skin.primary_color" v-for="answer in question.answers" :label="answer.answer"
                  :value="answer.answerCode" :key="question.questionCode + answer.answerCode + index"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-form>
        <v-flex v-if="!specificConditionsQuestions">
          <p class="mt-4">{{ $t("SpecificConditions.Labels.textWarranty") }} </p>
        </v-flex>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn depressed color="orange" class="subPrimary--text" @click="close">{{
        $t("SpecificConditions.Actions.Cancel")
        }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn :block="$isMobileDevice" @click="inquiry()" class="white--text" large depressed
          :color="skin.primary_color">{{
          $t("Actions.Inquiry")
          }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { inPage } from "@/utils";

export default {
  name: "SpecificConditions",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      zIndex: 0
    }
  },
  computed: {
    ...mapState({
      specificConditionsQuestions: state => state.parts.specificConditionsQuestions,
      specificConditionsAnswer: state => state.parts.specificConditionsAnswer,
      skin: state => state.settings.skin,
    }),
    ...mapGetters({
      basicCatalogRequest: 'parts/basicCatalogRequest',
    }),
  },
  methods: {
    ...mapActions({
      INQUIRY: "parts/INQUIRY",
      ANSWER_SPECIFIC_CONDITION_QUESTION: "parts/ANSWER_SPECIFIC_CONDITION_QUESTION",
      RESET_ALL_SPECIFIC_CONDITION: 'parts/RESET_ALL_SPECIFIC_CONDITION',
    }),
    setAnswer(question, index, answer) {
      this.ANSWER_SPECIFIC_CONDITION_QUESTION({ question, index, answer });
    },
    inPage,
    close() {
      !inPage("parts-result") && this.RESET_ALL_SPECIFIC_CONDITION();

      this.$root.$emit("close-modal", "SCQ");
    },
    async inquiry() {
      this.$root.$emit("close-modal", "SCQ");
      await this.INQUIRY({request: this.basicCatalogRequest, page: 1, size: 25, group_by: 'manufacturer' });
    }
  },
};
</script>